import { tracked } from '@glimmer/tracking';

import FilterSortBoardAtSelectPopup from 'webapp/models-custom/filter-sort/board-at-select-popup';

export default class FilterSortBoardAtSelectPopupInList extends FilterSortBoardAtSelectPopup {
	@tracked override viewId = 'table';
	override itemDomSelector = '.filter-sort-item';
}
